import {
  Box,
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "./Layout";
import RefundForm from "./RefundForm";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "16px",
  },
  title: {
    fontWeight: 600,
  },
  row: {
    "&:nth-child(odd)": {
      backgroundColor: "#f0f0f0",
    },
  },
}));

const Order = () => {
  const history = useHistory();
  const classes = useStyles();
  const [orderInfo, setOrderInfo] = useState([]);
  const [deliveryInfo, setDeliveryInfo] = useState([]);
  const [items, setItems] = useState([]);
  const [fio, setFio] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isOnlinePayment, setIsOnlinePayment] = useState(false);
  const [custom, setCustom] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/order/get`, { withCredentials: true })
      .then(({ data }) => {
        console.log('data', data);
        console.log('data', data.items.length);
        if (data.items.length == 0) {
          setOrderInfo([
            { key: "Номер заказа:", value: data.number },
          ]);
          setCustom(true);
        } else {
          setItems(data.items);
          setFio(data.buyer);
          setEmail(data.mail);
          setPhone(data.phone);
          setIsOnlinePayment(data.isOnlinePayment);
          setOrderInfo([
            { key: "Номер заказа:", value: data.number },
            { key: "Дата создания заказа:", value: data.createdDate },
            { key: "Сайт магазина:", value: data.siteName },
            { key: "Покупатель:", value: data.buyer },
          ]);
          setDeliveryInfo([
            { key: "Получатель:", value: data.recipient },
            { key: "Телефон:", value: data.phone },
            { key: "Почта:", value: data.mail },
            { key: "Способ доставки:", value: data.deliveryMethod },
            { key: "Служба доставки:", value: data.deliveryService },
            { key: "Адрес доставки:", value: data.deliveryAddress },
            { key: "Стоимость доставки:", value: data.deliveryCost },
            { key: "Дата отгрузки:", value: data.shipmentDate },
            {
              key: "Дата передачи в транспортную компанию:",
              value: data.responsibleStorageDate,
            },
          ]);
        }
      })
      .catch((e) => {
        setOrderInfo([
          { key: "Номер заказа:", value: '1234' },
        ]);
        console.log(e)
      });
  }, []);
  console.log('test6');
  console.log(orderInfo.length);

  return (
    <>
        <Layout>
          <Container maxWidth="md">
            <Paper elevation={0} className={classes.paper}>
              {/* Order info */}
              {!!orderInfo.length && (
              <Container
                style={{
                  marginBottom: "36px",
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
              >
                <Grid
                  container
                  justify="center"
                  style={{ marginBottom: "16px" }}
                >
                  <Typography variant="h6" className={classes.title}>
                    Заказ
                  </Typography>
                </Grid>
                {orderInfo.map(({ key, value }, i) => (
                  <Grid
                    container
                    justify="space-between"
                    className={classes.row}
                    key={i}
                  >
                    <Box component="span" m={1}>
                      {key}
                    </Box>
                    <Box component="span" m={1}>
                      {value}
                    </Box>
                  </Grid>
                ))}
              </Container>
              )}
              {/* delivery info */}
              {!!deliveryInfo.length && (
              <Container
                style={{
                  marginBottom: "36px",
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
              >
                <Grid
                  container
                  justify="center"
                  style={{ marginBottom: "16px" }}
                >
                  <Typography variant="h6" className={classes.title}>
                    Доставка
                  </Typography>
                </Grid>
                {deliveryInfo.map(({ key, value }, i) => (
                  <Grid
                    container
                    justify="space-between"
                    className={classes.row}
                    key={i}
                  >
                    <Box component="span" m={1}>
                      {key}
                    </Box>
                    <Box component="span" m={1}>
                      {value}
                    </Box>
                  </Grid>
                ))}
              </Container>
              )}
              {/* List products */}
              {!custom && (
              <div style={{ overflowX: "auto" }}>
                <Container
                  style={{
                    marginBottom: "36px",
                    paddingLeft: 0,
                    paddingRight: 0,
                    minWidth: "740px",
                  }}
                >
                  <Grid
                    container
                    justify="center"
                    style={{ marginBottom: "16px" }}
                  >
                    <Typography variant="h6" className={classes.title}>
                      Список товаров
                    </Typography>
                  </Grid>
                  <Grid container className={classes.row}>
                    <Grid item xs={2}>
                      <Box m={1}>Код</Box>
                    </Grid>
                    <Grid item xs={2}>
                      <Box m={1}>Название</Box>
                    </Grid>
                    <Grid item xs={2}>
                      <Box m={1}>Кол-во</Box>
                    </Grid>
                    <Grid item xs={2}>
                      <Box m={1}>Цена</Box>
                    </Grid>
                    <Grid item xs={2}>
                      <Box m={1}>Скидка</Box>
                    </Grid>
                    <Grid item xs={2}>
                      <Box m={1}>Сумма</Box>
                    </Grid>
                  </Grid>
                  {items.map((item) => (
                    <Grid
                      container
                      justify="space-between"
                      className={classes.row}
                      key={item.codeItem}
                    >
                      <Grid item xs={2}>
                        <Box m={1}>{item.codeItem}</Box>
                      </Grid>
                      <Grid item xs={2}>
                        <Box m={1}>{item.nameItem}</Box>
                      </Grid>
                      <Grid item xs={2}>
                        <Box m={1}>{item.quantityItem}</Box>
                      </Grid>
                      <Grid item xs={2}>
                        <Box m={1}>{item.priceItem}</Box>
                      </Grid>
                      <Grid item xs={2}>
                        <Box m={1}>{item.discountItem}</Box>
                      </Grid>
                      <Grid item xs={2}>
                        <Box m={1}>{item.sumItem}</Box>
                      </Grid>
                    </Grid>
                  ))}
                </Container>
              </div>
              )}
              {/* Форма возврата */}
              <RefundForm items={items} fio={fio} email={email} phone={phone} isOnlinePayment={isOnlinePayment} custom={custom} />
            </Paper>
          </Container>
        </Layout>
    </>
  );
};

export default Order;
